import { Slider } from '@finn/ui-modules';
import { parseToHtml } from '@finn/ui-utils';
import React from 'react';

import { Review } from '~/types/reviews';
import UserReview from '~/ui-elements/Reviews/UserReview';

interface IProps {
  title: string;
  reviews: Review[];
}

const NPSSlider: React.FunctionComponent<IProps> = ({ title, reviews }) => {
  return (
    <>
      <div className="container">
        <h2 className="mb-16 mobile-t2-semibold md:web-t2-semibold">
          {parseToHtml(title)}
        </h2>
      </div>
      <Slider>
        {reviews.map((review) => (
          <UserReview key={review.id} review={review} />
        ))}
      </Slider>
    </>
  );
};

export default NPSSlider;
